import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import norecipients from "../../assets/img/userdashboard/hidden.avif";
import { BsFillPersonPlusFill } from "react-icons/bs";
import Sidebar from "./Sidebar";
import authDashHelper from "../../utils/AuthDashHelper";
import { recipientList, userProfile } from "../../utils/Api";

// Helper: mask account number to ********1234 (last 4 digits visible)
const maskAccountNumber = (accountNumber) => {
  if (!accountNumber) return "N/A";
  const str = String(accountNumber);
  if (str.length <= 4) return str;
  return "********" + str.slice(-4);
};

// Helper: resolve recipient display name
const getRecipientName = (item) => {
  if (item?.account_type === "business") {
    return item?.business_name || "N/A";
  }
  const fullName = `${item?.first_name || ""} ${item?.last_name || ""}`.trim();
  return fullName || item?.account_name || "N/A";
};

const UserRecipients = () => {
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [delete_id, setDelete_Id] = useState("");
  const handleClose = () => setShow(false);
  const [isActive, setActive] = useState("false");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const serverUrl = process.env.REACT_APP_API_URL;
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;
  const handleShow = (key) => {
    setShow(true);
    setDelete_Id(key);
  };

const totalPages = Math.ceil((data?.length || 0) / itemsPerPage);
const paginatedData = data?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

const LoadEdit = (id, payout_currency) => {
      navigate(`/edit-recipient-user`, {
      state: { id: id, payout_currency: payout_currency },
    });
  };

  const getList = () => {
    setLoading(true);
    recipientList()
      .then((res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const verifyKyc = async () => {
    let res = await userProfile();
    if (res.code === "200") {
      if (res?.data.is_digital_Id_verified !== "approved") {
        navigate(`/dashboard`);
      }
      let local = { ...res?.data };
      sessionStorage.removeItem("remi-user-dt");
      sessionStorage.setItem("remi-user-dt", JSON.stringify(local));
      getList();
    } else {
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    verifyKyc();
  }, []);

  const handleRemoveRecipientBankDetails = () => {
    axios
      .delete(`${serverUrl}/payment/recipient-update/${delete_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        handleClose();
        getList();
      })
      .catch(function (error) {});
  };

  return (
    <>
      {loading ? (
        <>
          <div className="loader-overly">
            <div className="loader"></div>
          </div>
        </>
      ) : (
        <></>
      )}
      {!loading ? (
        <span>
          {data && data?.length > 0 ? (
            <section className="user_recipients_section">
              <div className="form-head mb-4">
                <h2 className="text-black font-w600 mb-0">
                  <b>Recipients Lists</b>
                  <NavLink to="/add-new-recipient">
                    <button className="form-button addsingle_recepient">
                      <BsFillPersonPlusFill />
                      Add New Recipient
                    </button>
                  </NavLink>
                </h2>
              </div>
              <div className="col-lg-12">
                <div className="card fullwidth">
                  <div className="card-body">
                    <div className="table-responsive">
                      <Table className="table table-responsive-md card-table previous-transaction">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Recipient Name</th>
                            <th>Payout Country</th>
                            <th>Payout Currency</th>
                            <th>Bank Name</th>
                            <th>Bank Account</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
               {paginatedData?.map((item, index) => {
  return (
    <tr key={item.id}>
      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                                {/* Recipient Name */}
                                <td>{getRecipientName(item)}</td>

                                <td>{item?.payout_country || "-"}</td>

                                <td>{item?.payout_currency || "-"}</td>

                                <td>{item?.bank_name || "-"}</td>
                                {/* Masked bank account number */}
                                <td>
                                  <span
                                    style={{
                                      fontFamily: "monospace",
                                      letterSpacing: "0.05em",
                                    }}
                                  >
                                    {maskAccountNumber(item?.account_number)}
                                  </span>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => handleShow(item.id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                      LoadEdit(item.id, item.payout_currency);
                                    }}
                                  >
                                    <i className="fa fa-pencil color-muted"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

{totalPages > 1 && (
  <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
      disabled={currentPage === 1}
    >
      Previous
    </button>

    {[...Array(totalPages)].map((_, i) => (
      <button
        key={i}
        className={`btn btn-sm ${currentPage === i + 1 ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => setCurrentPage(i + 1)}
      >
        {i + 1}
      </button>
    ))}

    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
      disabled={currentPage === totalPages}
    >
      Next
    </button>
  </div>
)}
                    </div>
                    <Modal show={show} onHide={handleClose} backdrop="static">
                      <Modal.Header></Modal.Header>
                      <Modal.Body>Are you sure you want to delete ?</Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => handleClose()}
                        >
                          Close
                        </Button>
                        <Button
                          className="delete_recipient"
                          variant="danger"
                          onClick={() => {
                            handleRemoveRecipientBankDetails();
                          }}
                        >
                          Delete
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <>
              <section>
                <div className="form-head mb-4">
                  <h2 className="text-black font-w600 mb-0">
                    <b>Add Recipient</b>
                  </h2>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="add-rec-new">
                      <h6 className="my-2">No Recipient Found</h6>
                      <img src={norecipients} alt="empty" />
                    </div>
                  </div>
                </div>
                <div
                  className={
                    isActive
                      ? "add-recipent-section"
                      : "remove-add-recipent-section"
                  }
                >
                  <div className="col-md-12 align-center">
                    <NavLink to="/add-new-recipient">
                      <button className="form-button addsingle_recepient">
                        <BsFillPersonPlusFill />
                        Add New Recepients
                      </button>
                    </NavLink>
                  </div>
                </div>
              </section>
            </>
          )}
        </span>
      ) : (
        <>
          <div className="loader-overly">
            <div className="loader"></div>
          </div>
        </>
      )}
    </>
  );
};

export default UserRecipients;
